import React from "react";
import SingleStringSetting from "fantastic/components/common/controls/SingleStringSetting";
import SlideredNumberSetting from "fantastic/components/common/controls/SlideredNumberSetting";
import HorizontalPositionSettings from "fantastic/components/common/controls/background/HorizontalPositionSettings";
import UrlSetting from "fantastic/components/common/controls/UrlSetting";
import settingable from "fantastic/components/hoc/settingable";

const ButtonSettings = ({ selected, update, selectedNode }) => {
  const onChange = (field) => {
    return (value) => {
      update(selected, { [field]: value });
    }
  };

  const positionSetting = {
    onChange: (_field, value) => onChange('text_align')(value),
    options: ['left', 'center', 'right', 'justify'],
    position: {
      field: "text_align",
      value: selectedNode.text_align || 'justify'
    }
  };

  return (
    <div>
      <SingleStringSetting value={selectedNode.label} onChange={onChange('label')} label={i18n.t('text')} />
      <UrlSetting value={selectedNode.href} onChange={onChange('href')} />
      <div className="form-group">
        <label>{ i18n.t('text_align') }</label>
        <div>
          <HorizontalPositionSettings {...positionSetting} />
        </div>
      </div>
      <SlideredNumberSetting
        min={0}
        max={100}
        step={1}
        value={selectedNode.height}
        label={i18n.t('size')}
        onChange={onChange('height')}
      />
      <SlideredNumberSetting
        min={0}
        max={100}
        step={1}
        value={selectedNode.css_border_radius}
        label={i18n.t('border_radius')}
        onChange={onChange('css_border_radius')}
      />
    </div>
  );
};

export default settingable("background", "padding", "border-color", "font", "visibility")(ButtonSettings);
